export default function queryString() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var arr = [];

  for (var key in data) {
    arr.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(data[key])));
  }

  return arr.join('&');
}